<h1 mat-dialog-title class="z5-main-header">Update legal document <small class="align-top">- {{dialogData.terms.displayName}}</small></h1>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()" [z5FormChanges]="formChanges" (z5FormChangesChange)="formChange($event)" [z5FormChangesBase]="formChangesBase">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<mat-form-field appearance="standard" class="col-12 col-sm-6 legal-update__name">
				<mat-label i18n>Document name</mat-label>
				<input matInput type="text" placeholder="Name" i18n-placeholder formControlName="name" />
				<mat-error appFormErrorMessage [errorFormControl]="formInputs.controls.name" [type]="formEditorInputType.text"></mat-error>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-sm-6 legal-update__alias">
				<mat-label i18n>Document alias</mat-label>
				<input matInput type="text" placeholder="Alias" i18n-placeholder formControlName="alias" />
				<mat-error appFormErrorMessage [errorFormControl]="formInputs.controls.alias" [type]="formEditorInputType.text"></mat-error>
			</mat-form-field>

			<div class="col-12 mt-2">
				<app-legal-app-localisation [(formInputs)]="formInputs" [(displayNames)]="dialogData.terms.displayNames"></app-legal-app-localisation>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="row mb-0">
		<div class="col-12" *ngIf="!hasChanges">
			<button class="w-100" mat-stroked-button mat-dialog-close i18n>Close</button>
		</div>
		<ng-container *ngIf="hasChanges">
			<div class="col-6 text-center">
				<button class="w-100" mat-stroked-button mat-dialog-close i18n>Cancel</button>
			</div>
			<div class="col-6 text-center">
				<button mat-flat-button color="primary" class="w-100" [disabled]="formInputs.invalid" type="submit" i18n>Save</button>
			</div>
		</ng-container>
	</div>
</form>
